/** Helper for joining class names together. Accepts strings or objects. It filters out falsey values. */
export default function classnames(...args: (string | Record<string, boolean | undefined> | undefined)[]) {
  // separate out strings and objects
  const objects = args.filter((arg) => typeof arg === "object") as Record<string, boolean>[];
  const strings = args.filter((arg) => typeof arg === "string") as string[];

  // get all classname keys with truthy value
  const objectKeys = objects.map((obj) => Object.keys(obj).filter((key) => !!obj[key])).flat();

  // combine everything
  const results = [...strings, ...objectKeys].filter(Boolean).join(" ").trim();

  return results;
}
